<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="back" @click="$router.go(-1)" />
        <action-button type="save" @click="save" />
        <action-button type="delete" @click="del(notification.id)" v-if="$can('notification-delete')" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex md3 xs12>
                <v-autocomplete
                  multiple
                  name="notification.site"
                  class="required-field"
                  v-validate="'required'"
                  v-model="selected_tenants"
                  :items="tenants"
                  item-text="subdomain"
                  item-value="id"
                  :label="$t('notifications.site')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('notification.site')"
                >
                  <template v-slot:prepend-item>
                    <v-list-item ripple dense class="select-all" @click="fn_toggleSelectAllTenants">
                      <v-list-item-icon>
                        <v-checkbox v-model="toggleSelectAllTenants" color="primary" readonly></v-checkbox>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{ $t("global.select_all") }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                </v-autocomplete>
              </v-flex>
              <v-flex md9 xs12>
                <v-text-field
                  name="notification.header"
                  v-model="notification.header"
                  class="required-field"
                  v-validate="'required'"
                  :label="$t('notifications.header')"
                  :error-messages="errors.collect('notification.header')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <quill-editor
                  name="notification.body"
                  v-model="notification.body"
                  :options="editorOption"
                  class="required-field"
                  v-validate="'required'"
                  :label="$t('notifications.body')"
                  :error-messages="errors.collect('notification.body')"
                ></quill-editor>
                <!--<v-text-field
                  name="notification.body"
                  v-model="notification.body"
                  class="required-field"
                  v-validate="'required'"
                  :label="$t('notifications.body')"
                  :error-messages="errors.collect('notification.body')"
                  autocomplete="new-password"
                ></v-text-field>-->
              </v-flex>
              <v-flex lg2 md4 sm6 xs12>
                <v-select
                  name="notification.type"
                  v-model="notification.type"
                  class="required-field"
                  v-validate="'required'"
                  item-text="text"
                  item-value="key"
                  :items="$dd_notification_type()"
                  :label="$t('notifications.type')"
                  :error-messages="errors.collect('notification.type')"
                  clearable
                ></v-select>
              </v-flex>
              <v-flex lg2 md3 sm6 xs8>
                <v-dialog ref="dialog" v-model="start_date_menu" persistent width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      name="notification.start_date"
                      v-model="computedStartDate"
                      :label="$t('notifications.start_date')"
                      class="required-field"
                      v-validate="'required|validDate'"
                      :error-messages="errors.collect('notification.start_date')"
                      append-icon="event"
                      @click:append="start_date_menu = true"
                      :hint="'Format: ' + DATE_FORMAT"
                      autocomplete="new-password"
                    ></v-text-field>
                  </template>
                  <v-date-picker color="primary" v-model="notification.start_date" first-day-of-week="1" :locale="this.$locale_bcp47()">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="start_date_menu = false" class="darken-2">{{ $t("global.ok") }}</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex lg2 md3 sm6 xs4>
                <v-dialog ref="dialog" v-model="start_time_menu" persistent width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      name="notification.start_time"
                      v-model="computedStartTime"
                      :label="$t('notifications.start_time')"
                      class="required-field"
                      v-validate="'required|validTime'"
                      :error-messages="errors.collect('notification.start_time')"
                      append-icon="schedule"
                      @click:append="start_time_menu = true"
                      :hint="'Format: ' + TIME_FORMAT"
                      autocomplete="new-password"
                    ></v-text-field>
                  </template>
                  <v-time-picker color="primary" v-model="notification.start_time" format="24hr">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="start_time_menu = false" class="darken-2">{{ $t("global.ok") }}</v-btn>
                  </v-time-picker>
                </v-dialog>
              </v-flex>
              <v-flex lg2 md3 sm6 xs8 v-if="notification.type != 'push-notification'">
                <v-dialog ref="dialog" v-model="end_date_menu" persistent width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      name="notification.end_date"
                      v-model="computedEndDate"
                      :label="$t('notifications.end_date')"
                      class="required-field"
                      v-validate="'required|validDate'"
                      :error-messages="errors.collect('notification.end_date')"
                      append-icon="event"
                      @click:append="end_date_menu = true"
                      :hint="'Format: ' + DATE_FORMAT"
                      autocomplete="new-password"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    color="primary"
                    v-model="notification.end_date"
                    first-day-of-week="1"
                    :locale="$locale_bcp47()"
                    :min="notification.start_date"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="end_date_menu = false" class="darken-2">{{ $t("global.ok") }}</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex lg2 md3 sm6 xs4 v-if="notification.type != 'push-notification'">
                <v-dialog ref="dialog" v-model="end_time_menu" persistent width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      name="notification.end_time"
                      v-model="computedEndTime"
                      :label="$t('notifications.end_time')"
                      class="required-field"
                      v-validate="'required|validTime'"
                      :error-messages="errors.collect('notification.end_time')"
                      append-icon="schedule"
                      @click:append="end_time_menu = true"
                      :hint="'Format: ' + TIME_FORMAT"
                      autocomplete="new-password"
                    ></v-text-field>
                  </template>
                  <v-time-picker color="primary" v-model="notification.end_time" format="24hr">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="end_time_menu = false" class="darken-2">{{ $t("global.ok") }}</v-btn>
                  </v-time-picker>
                </v-dialog>
              </v-flex>
              <v-flex lg2 md4 sm6 xs12>
                <v-select
                  name="notification.status"
                  v-model="notification.status"
                  class="required-field"
                  v-validate="'required'"
                  item-text="text"
                  item-value="key"
                  :items="$dd_notification_status()"
                  :label="$t('notifications.status')"
                  :error-messages="errors.collect('notification.status')"
                  :disabled="Boolean(!notification.id)"
                  clearable
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
import "quill/dist/quill.core.css"
import "quill/dist/quill.snow.css"
import "quill/dist/quill.bubble.css"
import { quillEditor } from "vue-quill-editor"

export default {
  name: "NotificationForm",

  props: ["id"],

  components: {
    quillEditor
  },

  data() {
    return {
      page_title: "",
      predata: {},
      notification: {},

      tenants: [],
      selected_tenants: [],

      toggleSelectAllTenants: false,

      start_date_menu: false,
      start_time_menu: false,
      end_date_menu: false,
      end_time_menu: false,

      editorOption: {
        modules: {
          toolbar: [[{ header: [1, 2, 3, 4, 5, 6, false] }], ["bold", "italic"], [{ list: "ordered" }, { list: "bullet" }]]
        }
      },

      dictionary: {
        attributes: {
          "notification.site": this.$t("notifications.site"),
          "notification.header": this.$t("notifications.header"),
          "notification.body": this.$t("notifications.body"),
          "notification.start_date": this.$t("notifications.start_date"),
          "notification.start_time": this.$t("notifications.start_time"),
          "notification.end_date": this.$t("notifications.end_date"),
          "notification.end_time": this.$t("notifications.end_time"),
          "notification.status": this.$t("notifications.status"),
          "notification.type": this.$t("notifications.type")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.notification, this.predata, this.save, this.isFormValid)
    })
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    },
    computedStartDate: {
      get() {
        return this.$dateFormatGetter(this.notification.start_date)
      },
      set(val) {
        this.$set(this.notification, "start_date", this.$dateFormatSetter(val))
      }
    },
    computedStartTime: {
      get() {
        return this.$timeFormatGetter(this.notification.start_time)
      },
      set(val) {
        this.$set(this.notification, "start_time", this.$timeFormatSetter(val))
      }
    },
    computedEndDate: {
      get() {
        return this.$dateFormatGetter(this.notification.end_date)
      },
      set(val) {
        this.$set(this.notification, "end_date", this.$dateFormatSetter(val))
      }
    },
    computedEndTime: {
      get() {
        return this.$timeFormatGetter(this.notification.end_time)
      },
      set(val) {
        this.$set(this.notification, "end_time", this.$timeFormatSetter(val))
      }
    }
  },

  watch: {
    toggleSelectAllTenants(val) {
      if (val) {
        this.selected_tenants = this.tenants.map((a) => a.id)
      } else {
        this.selected_tenants = []
      }
    },
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    let lists = [
      {
        key: "tenants",
        module: "tenants",
        query: "show_all=true&query_type=1&query_status=1"
      }
    ]

    axios.post(this.API_URL + "request/ddlists", lists).then((res) => {
      this.tenants = res.data.tenants
      this.tenants = [{ id: -1, subdomain: "[ " + this.$t("global.sb_title") + " ]" }, ...this.tenants]

      if (!this.id) {
        this.notification = {
          start_date: this.moment().format(this.MYSQL_DATE_FORMAT),
          start_time: this.moment.utc("08:00", this.TIME_FORMAT).format(this.TIME_FORMAT),
          end_date: this.moment().format(this.MYSQL_DATE_FORMAT),
          end_time: this.moment.utc("16:00", this.TIME_FORMAT).format(this.TIME_FORMAT),
          type: this.$getDefaultDropdown(this.$dd_notification_type()),
          status: this.$getDefaultDropdown(this.$dd_notification_status())
        }
        this.predata = JSON.parse(JSON.stringify(this.notification))
        this.setPageTitle()
      } else {
        this.title = this.$t("notifications.update_title")

        axios
          .get(this.API_URL + "notification/" + this.id)
          .then((res) => {
            this.notification = res.data.data
            this.selected_tenants = this.notification.tenant_ids
            this.predata = JSON.parse(JSON.stringify(this.notification))
            this.setPageTitle()
          })
          .catch((err) => console.log(err))
      }
    })
  },

  methods: {
    setPageTitle() {
      if (_.has(this.notification, "id")) {
        this.page_title = this.$t("notifications.edit_notification", {
          name: this.notification.header
        })
      } else {
        this.page_title = this.$t("notifications.new_notification")
      }
    },
    fn_toggleSelectAllTenants() {
      this.toggleSelectAllTenants = !this.toggleSelectAllTenants
    },
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this
            let user = this.$store.getters["auth/user"]

            if (!this.notification.id) {
              // Create
              axios
                .post(this.API_URL + "notification", {
                  tenant_ids: this.selected_tenants.join(","),
                  header: this.notification.header,
                  body: this.notification.body,
                  start_datetime: this.notification.start_date + " " + this.notification.start_time,
                  end_datetime: this.notification.type != 'push-notification' ? this.notification.end_date + " " + this.notification.end_time : null,
                  status: this.notification.status,
                  type: this.notification.type,
                  created_by: user.id
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.notification = res.data.data
                      vm.predata = JSON.parse(JSON.stringify(vm.notification))
                      vm.setPageTitle()

                      vm.$awn.success(vm.$t("global.create_success"))
                      vm.$router.replace(this.BACKEND_URL + `/notifications/edit/${vm.notification.id}`).catch(() => {})
                    }
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "notification", {
                  id: this.notification.id,
                  tenant_ids: this.selected_tenants.join(","),
                  header: this.notification.header,
                  body: this.notification.body,
                  start_datetime: this.notification.start_date + " " + this.notification.start_time,
                  end_datetime: this.notification.type != 'push-notification' ? this.notification.end_date + " " + this.notification.end_time : null,
                  status: this.notification.status,
                  type: this.notification.type
                })
                .then((res) => {
                  vm.notification = res.data.data
                  vm.predata = JSON.parse(JSON.stringify(vm.notification))

                  vm.setPageTitle()
                  vm.$awn.success(vm.$t("global.update_success"))
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "notification/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/notifications")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    }
  }
}
</script>

<style scoped></style>
